import { Vector3 } from 'three';
import { IPoint, IPoint3d } from './IPoint3d';
import { thresholdValue } from './const';

export function isPoint3d(point: IPoint): point is IPoint3d {
  return 'z' in point && point.z !== undefined;
}

export class Point3dUtils {
  static clone(point: IPoint3d): IPoint3d {
    const clonePt = { x: point.x, y: point.y, z: point.z };
    return clonePt;
  }

  static added(point: IPoint3d, vec: Vector3 | IPoint3d): IPoint3d {
    const addPoint = { x: point.x + vec.x, y: point.y + vec.y, z: point.z + vec.z };
    return addPoint;
  }

  static subtracted(point: IPoint3d, subPoint: IPoint3d): IPoint3d {
    const subtractPoint = { x: point.x - subPoint.x, y: point.y - subPoint.y, z: point.z + subPoint.z };

    return subtractPoint;
  }

  /**
   * 判断两点是否相同（考虑浮点误差）
   */
  static equals(point1: IPoint3d, point2: IPoint3d, tolerance: number = thresholdValue): boolean {
    return (
      Math.abs(point1.x - point2.x) < tolerance &&
      Math.abs(point1.y - point2.y) < tolerance &&
      Math.abs(point1.z - point2.z) < tolerance
    );
  }

  static getCenter(point1: IPoint3d, point2: IPoint3d): IPoint3d {
    return { x: (point1.x + point2.x) / 2, y: (point1.y + point2.y) / 2, z: (point1.z + point2.z) / 2 };
  }
}
